import { QUESTION } from './terminology';

const EXCLUDED_MESSAGE_POSTFIX = `If unsure, please review the ${QUESTION.SINGULAR} management page or speak to your administrator.`;

export const AI_MESSAGE = {
  EXCLUDED_METRIC_SINGULAR: `This ${QUESTION.SINGULAR} has been excluded from AI processing. ${EXCLUDED_MESSAGE_POSTFIX}`,
  EXCLUDED_METRIC_PLURAL: `Some ${QUESTION.PLURAL} may be excluded from AI processing. ${EXCLUDED_MESSAGE_POSTFIX}`,
};
